import FileDownload from '@/services/FileDownload'

export default function (params) {
    return FileDownload('/api/v1/users/export', params)
}
